import React from "react";
//import PropTypes from "prop-types";

function GridMenu(props) {
  return <div>Grid menu boxes</div>;
}

export default GridMenu;



// WEBPACK FOOTER //
// ./src/components/ModuleMenu/GridMenu.js